/**
 * Shape Primitives — raw border radius values.
 */

export const borderRadiusValues = {
  none: "0px",
  base: "4px",
  md: "6px",
  lg: "12px",
  pill: "9999px",
  full: "50%",
} as const;
